<template>
  <div class="min-h-screen">
    <div class="m-3 rounded-md bg-white p-2">
      <ve-table :columns="columns" :table-data="tableData" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Structure",
  data() {
    return {
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "Department", key: "a", title: "Department" },
        { field: "Location", key: "b", title: "Location" },
        { field: "Number", key: "c", title: "No. of employees" },
        {
          field: "Contact",
          key: "x",
          title: "Contact",
          renderBodyCell: ({ row }) => {
            return (
              <p class="hover:underline text-blue-500 cursor-pointer">
                {row.Contact}
              </p>
            );
          },
        },
        { field: "Manager", key: "d", title: "Manager" },
        { field: "Status", key: "e", title: "Status" },
        { field: "Action", key: "f", title: "Action", renderBodyCell: () => {
            return <p class="cursor-pointer transform rotate-90 font-bold">&#8230;</p>;
          }, },
      ],
      tableData: [
        {
          Department: "Sales",
          Location: "Nairobi",
          Number: "20",
          Contact: "+254 704 456 894",
          Manager: "+254 704 456 894",
          Status: "Active",
          Action: ":",
        },
        {
          Department: "Sales",
          Location: "Nairobi",
          Number: "20",
          Contact: "+254 704 456 894",
          Manager: "John Doe",
          Status: "Active",
          Action: ":",
        },
        {
          Department: "Sales",
          Location: "Nairobi",
          Number: "20",
          Contact: "+254 704 456 894",
          Manager: "John Doe",
          Status: "Active",
          Action: ":",
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>